<template>
    <div class="across-section"
         @dragover.stop="dragOver"
         @dragleave.stop="dragleave"
         @drop.stop="onDrop"
         :style="acrossSectionStyle"
         v-show="visible">
        <transition-group tag="ul"
                          class="page-ellipsis"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @leave="leave">
            <li v-for="(item, index) in computedList"
                :key="item"
                v-bind:data-index="index"></li>
        </transition-group>

        <div class="across-section-tip"
             :style="acrossTipStyle"
             v-if="visibleTip && visible">松<br />开<br />放<br />置<br />骑<br />缝<br />章</div>
    </div>
</template>

<script>
export default {
    props: {
        dragInfo: Object,
        showAcrossSection: Boolean
    },
    data () {
        return {
            visibleTip: false,
            pageCount: 6,
        }
    },
    computed: {
        visible () {
            return this.dragInfo.acrossSectionVisible && this.showAcrossSection
        },
        computedList () {
            return this.visible ? Array(this.pageCount).fill().map((_, i) => i + 1) : []
        },
        acrossSectionStyle () {
            const { acrossSectionWidth  = 120 } = this.dragInfo;
            return {
                width: acrossSectionWidth * 1.5 + 'px',
                paddingLeft: (2 + acrossSectionWidth * 0.5) + 'px',
                right: -acrossSectionWidth + 'px',
            }
        },

        acrossTipStyle () {
            const { acrossSectionWidth = 120 } = this.dragInfo;
            return {
                fontSize: acrossSectionWidth * 0.3 + 'px',
                width: acrossSectionWidth + 'px',
            }

        }
    },
    methods: {
        beforeEnter (el) {
            el.style.opacity = 0
            el.style.width = 0
        },
        enter (el) {
            var delay = el.dataset.index * 100
            const count = 1 / this.pageCount * 100
            setTimeout( () =>{
                el.style.width = count + '%';
                el.style.opacity = 1;
            }, delay)
        },
        leave (el) {
            var delay = el.dataset.index * 100
            setTimeout( ()=> {
                el.style.width = '0px';
                el.style.opacity = 0;
            }, delay)
        },
        dragOver (e) {
            e.preventDefault();
            this.visibleTip = true;
        },
        dragleave () {
            this.visibleTip = false;
        },
        onDrop (e) {
            this.visibleTip = false;
            this.$emit('drop', e, 'ACROSS')
        }
    },

}
</script>

<style lang="less" scoped>
.across-section {
    position: absolute;
    height: 100%;
    box-sizing: border-box;
    top: 0px;
    .page-ellipsis {
        height: 100%;
        padding: 0px;
        margin: 0;
        background:white;
        li {
            list-style: none;
            float: left;
            transition: 0.3s ease;
            box-shadow: 2px 0px 3px rgba(144, 147, 153, 0.4);
            height: 100%;
            box-sizing:border-box;
        }
    }
    .across-section-tip {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        pointer-events: none;
        top: 0;
        right: 0;
        height: 100%;
        z-index: 200;
        background: rgba(36, 137, 242, 0.1);
        font-weight: 400;
        color: rgba(193, 198, 205, 0.5);
        box-sizing: border-box;
    }
}
</style>